<template>
  <div class="eagleEyeList">
    <div class="filters">
      <el-form :inline="true">
        <el-form-item>
          <el-select v-model="formInline.housing" :placeholder="detail.allHouse" filterable>
            <!-- <el-option key="0" :label="detail.allHouse" value="0"></el-option> -->
            <el-option v-for="item in tableData" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-button type="primary" @click="search">{{$t('lang.btn_search')}}</el-button>
      </el-form>
    </div>
    <el-card>
      <el-button slot="header" size="medium" type="primary" @click="jumpToAdd">{{$t('lang.eagleEye.add')}}</el-button>
      <el-table :data="eagleEyeList" class="wid100" :row-class-name="tableRowClassName"
        :height="eagleEyeList.length > 0 ? require('@/config/enum').tableheight529 : require('@/config/enum').tableheight109"
        @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55" v-if="this.eagleEyeListcheckbox"></el-table-column>
        <el-table-column type="index" :index="indexMethod" align="center" :label="$t('lang.lab_index')" width="100px">
        </el-table-column>
        <el-table-column prop="gardenName" :label="detail.housing">
        </el-table-column>
        <el-table-column prop="monitorPositionName" :label="detail.eagleLocation">
        </el-table-column>
        <el-table-column prop="videoMonitorTypeName" :label="detail.videoMonitorTypeName">
        </el-table-column>
        <el-table-column prop="appId" label="鹰眼设备appId">
        </el-table-column>
        <el-table-column prop="streamId" label="鹰眼设备国标ID">
        </el-table-column>
        <el-table-column prop="operation" :label="$t('lang.lab_operation')"
          :width="require('@/config/enum').opr_width2">
          <template slot-scope="scope">
            <el-button @click="edit(scope.row)">{{$t('lang.btn_modify')}}</el-button>
            <el-button class="orange" @click="deleteItem(scope.row)">{{$t('lang.btn_delete')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNum"
        :page-sizes="[10, 20, 30, 50]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
        :page-count="pageCount" />
      <el-dialog :title="state? $t('lang.eagleEye.add'):$t('lang.eagleEye.alter')" :visible.sync="review"
        :close-on-click-modal="false" center top="130px" width="600px" @closed="handleDialogClosed">

        <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="120px" @submit.native.prevent
          class="form">
          <el-form-item :label="detail.whereAt" prop="name">
            <el-select class="select" @change="selectBuilding" v-model="ruleForm.name" :placeholder="detail.chooseAt">
              <el-option v-for="item in tableData" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="detail.hBuilding" prop="Building">
            <el-select class="select" @change="selectCell" v-model="ruleForm.Building"
              :disabled="!ruleForm.name?true:false" :placeholder="detail.chooseBuilding">
              <el-option :label="detail.chooseBuilding" :value=0></el-option>
              <el-option v-for="item in houseBuilding" :key="item.value" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="detail.cell" prop="cell">
            <el-select class="select" v-model="ruleForm.cell" placeholder="" :disabled="!ruleForm.Building?true:false">
              <el-option :label="detail.choosecell" :value=0></el-option>
              <el-option v-for="item in cell" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="detail.videoMonitorTypeName" prop="videoMonitorTypeId">
            <el-select v-model="ruleForm.videoMonitorTypeId" class="select">
              <el-option v-for="item in videoMonitorTypes" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="detail.whereName" prop="locationName">
            <el-input maxlength='50' class="select" v-model="ruleForm.locationName" :placeholder="detail.fillWhereName">
            </el-input>
          </el-form-item>
          <el-form-item label="鹰眼设备appId" prop="appId">
            <el-input class="select" v-model="ruleForm.appId" placeholder="请输入鹰眼设备appId"></el-input>
          </el-form-item>
          <el-form-item label="鹰眼设备国标ID" prop="streamId">
            <el-input class="select" v-model="ruleForm.streamId" placeholder="请输入鹰眼设备国标ID"></el-input>
          </el-form-item>
        </el-form>

        <div slot="footer">
          <el-button @click="resetForm('ruleForm')">{{$t('lang.btn_rest')}}</el-button>
          <el-button :disabled="isDisabled" type="primary" @click="onSubmit('ruleForm')">{{$t('lang.btn_save')}}
          </el-button>
        </div>
      </el-dialog>
    </el-card>
  </div>
</template>
<script>
  /**
   *@ClassName:eagleEyeList
   *@Description:园区鹰眼接口
   *@author:邹恒志
   *@Copyright:格众科技
   *@date:2020-02-27
   */
  import axios from 'axios'
  import Qs from 'qs'
  export default {
    name: '/manage/main.videoMonitorInterface',
    data() {
      // eslint-disable-next-line
      var reg = /(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/
      var validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error(this.$i18n.t('lang.lab_pleInputLink')))
        } else {
          if (!reg.test(value)) {
            callback(new Error(this.$i18n.t('lang.lab_pleInputRLink')))
          }
          callback()
        }
      }
      return {
        saveData: '', // 存储验证保存按钮字符串
        isDisabled: true, // 置灰标识
        multipleSelection: [], // 多选框
        houseid: [], // 保存根据id请求的数据后根据house 判断根据小区id请求回来的数据判断楼号
        state: true, // 判断是添加还是修改状态
        cell: [], //  存储根据楼号请求回来的单元
        houseBuilding: [], //  存储根据小区请求回来的楼号
        id: '', // 保存id
        flag: '', // 根据1或者0判断是保存还是修改
        rules: {
          name: [{
            required: true,
            message: this.$i18n.t('lang.eagleEye.chooseAt'),
            trigger: 'change'
          }],
          cell: [{
            required: false,
            message: this.$i18n.t('lang.eagleEye.choosecell'),
            trigger: 'blur'
          }],
          Building: [{
            required: false,
            message: this.$i18n.t('lang.eagleEye.chooseBuilding'),
            trigger: 'blur'
          }],
          locationName: [{
            required: true,
            message: this.$i18n.t('lang.eagleEye.fillWhereName'),
            trigger: 'blur'
          }],
          videoMonitorTypeId: [{
            required: true,
            message: this.$i18n.t('lang.eagleEye.choosevideoMonitorTypeName'),
            trigger: 'blur'
          }],
          appId: [{
            required: true,
            message: '请输入鹰眼设备appId',
            trigger: 'blur'
          }],
          streamId: [{
            required: true,
            message: '请输入鹰眼设备国标ID',
            trigger: 'blur'
          }],
        },
        ruleForm: {
          name: '', // 所在小区
          cell: '', // 单元
          Building: '', // 楼号 
          videoMonitorTypeId: '', // 鹰眼分类
          locationName: '', // 位置名称
          appId: 'gb28181', // 设备appId
          streamId: '', // 设备序列号
        },
        review: false, // 打开关闭dialog
        editListArr: [], // 保存修改列表所有数据
        pageCount: 0, // 总页数
        pageNum: 1, // 页数
        pageSize: 10, // 每页显示数量
        tableData: [], // 所有小区存储
        formInline: {
          housing: '', // 筛选时的id
        },
        eagleEyeList: [], // 详情列表
        videoMonitorTypes: [], // 鹰眼分类集合
        detail: this.$i18n.t('lang.eagleEye'),
        eagleEyeListcheckbox: require('@/config/enum').eagleEyeListcheckbox, // 是否隐藏复选框
      }
    },
    created() {
      this.gardens()
      this.topics()
      this.getVideoMonitorTypes()
      if (this.$store.getters.gardenId > 0) {
        this.formInline.housing = this.$store.getters.gardenId
      }
    },
    watch: {
      ruleForm: {
        handler(newVal, oldVal) {
          let tempRule = JSON.stringify(newVal)
          if (tempRule === this.saveData) {
            this.isDisabled = true
          } else {
            this.isDisabled = false
          }
          console.log(tempRule == this.saveData)
          console.log(tempRule)
          console.log(this.saveData)
        },
        deep: true,
        immediate: true
      },
    },
    methods: {
      // 序号,
      indexMethod(index) {
        return (this.pageNum - 1) * this.pageSize + index + 1
      },
      handleSelectionChange(val) {
        this.multipleSelection = val
      },
      // 点击楼号获取单元
      selectCell(id) {
        this.ruleForm.cell = 0
        this.$get(
          `/gardenGrids/?type=2&parentId=${id}&pageNo=1&pageSize=999`
        ).then(
          res => {
            if (res && res.errCode === 0) {
              this.cell = res.list
            }
          },
          error => {
            this.$message.error(error)
          }
        )
      },
      // 监听关闭dialog
      handleDialogClosed() {
        this.ruleForm.name = ''
        this.ruleForm.cell = ''
        this.ruleForm.Building = ''
        this.ruleForm.locationName = ''
        this.ruleForm.videoMonitorTypeId = ''
        this.$refs.ruleForm.resetFields()
      },
      // 点击保存按钮事件
      onSubmit(formName) {
        let params = {
          id: this.id,
          gardenId: this.ruleForm.name,
          house: this.ruleForm.Building,
          unit: this.ruleForm.cell,
          monitorPositionName: this.ruleForm.locationName,
          videoMonitorTypeId: this.ruleForm.videoMonitorTypeId,
          flag: this.flag,
          appId: this.ruleForm.appId,
          streamId: this.ruleForm.streamId,
        }
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.$post('/AOEVideoMonitorInterface1', params).then(res => {
              if (res.errCode == 0) {
                this.$message({
                  type: 'success',
                  message: this.flag == 1 ? this.$i18n.t('lang.eagleEye.addSucceed') : this.$i18n.t(
                    'lang.eagleEye.alterSucceed')
                })
                this.review = false
                this.commit()
              } else {
                this.$message({
                  type: 'success',
                  message: res.errMsg
                })
              }
            })
          }
        })
      },
      // 修改按钮事件
      edit(row) {
        this.gardens()
        this.flag = 0
        if (!row.unit) {
          row.unit = ''
        }
        if (!row.house) {
          row.house = undefined
        }
        this.ruleForm.name = row.gardenId
        this.ruleForm.cell = row.unit
        this.ruleForm.Building = row.house
        this.ruleForm.locationName = row.monitorPositionName
        this.ruleForm.videoMonitorTypeId = row.VideoMonitorTypeId
        this.ruleForm.appId = row.appId
        this.ruleForm.streamId = row.streamId
        // flag为1是添加 flag为0是修改
        this.state = false
        this.row = row
        this.id = row.id
        let loading = this.$loading()
        this.ruleForm.name = this.row.gardenId
        this.ruleForm.videoMonitorTypeId = this.row.VideoMonitorTypeId
        this.$get(`/getVideoMonitorInterfaceById1/${this.row.id}`).then(
          res => {
            loading.close()
            console.log(res)
            this.ruleForm.locationName = res.result.monitorPositionName
            this.houseid = res.result
            this.$get(`/gardenGrids?type=1&parentId=${this.houseid.gardenId}&pageNo=1&pageSize=999`).then(
              res => {
                loading.close()
                this.houseBuilding = res.list
                this.ruleForm.Building = res.list.id
                this.ruleForm.Building = this.houseid.house
                this.review = true
                if (this.houseid.unit) {
                  this.$get(`/gardenGrids?type=2&parentId=${this.houseid.house}&pageNo=1&pageSize=999`).then(
                    res => {
                      loading.close()
                      this.cell = res.list
                      this.ruleForm.cell = this.houseid.unit
                    }, error => {
                      loading.close()
                      this.$message.error(error)
                    }
                  )
                }
                this.saveData = JSON.stringify(this.ruleForm)
              }, error => {
                loading.close()
                this.$message.error(error)
              }
            )
          }, error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      // 添加页面弹出
      jumpToAdd() {
        this.state = true
        this.review = true
        this.id = 0
        this.flag = 1
        this.ruleForm.cell = ''
        this.ruleForm.Building = ''
        this.ruleForm.locationName = ''
        this.ruleForm.videoMonitorTypeId = ''
        this.ruleForm.appId = 'gb28181'
        this.ruleForm.streamId = ''
        if (this.$store.getters.gardenId > 0) {
          this.ruleForm.name = this.$store.getters.gardenId
          this.selectBuilding(this.$store.getters.gardenId)
        }
      },
      // 表格斑马
      tableRowClassName({
        row,
        rowIndex
      }) {
        return rowIndex % 2 === 0 ? 'row-dark' : ''
      },
      // 小区下拉
      gardens() {
        let loading = this.$loading()
        this.$get(`/gardens`).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              this.tableData = res.list
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      // 显示当前页全部小区鹰眼接口信息。
      topics() {
        let loading = this.$loading()
        this.$get(
          `/videoMonitorInterfaceList1?gardenId=` + this.$store.getters.gardenId + `+&pageSize=${this.pageSize}&pageNo=${this.pageNum}`
        ).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              this.eagleEyeList = res.list
              this.pageCount = res.pageCount
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      // 获取鹰眼分类List
      getVideoMonitorTypes() {
        this.$get(`getVideoMonitorTypes`).then(
          res => {
            if (res && res.errCode === 0) {
              this.videoMonitorTypes = res.result
            }
          },
          error => {
            this.$message.error(error)
          }
        )
      },
      // 查询方法
      search() {
        this.pageNum = 1
        this.commit()
      },
      // 提交按钮
      commit() {
        let loading = this.$loading()
        this.$get(
            `/videoMonitorInterfaceList1?gardenId=${this.formInline.housing}&pageSize=${this.pageSize}&pageNo=${this.pageNum}`
          )
          .then(
            res => {
              loading.close()
              if (res && res.errCode === 0) {
                this.eagleEyeList = res.list
                this.pageCount = res.pageCount
              }
            },
            error => {
              loading.close()
              this.$message.error(error)
            }
          )
      },
      // 翻页
      handleCurrentChange(val) {
        this.pageNum = val
        this.commit()
      },
      // 切换每页显示多少数据
      handleSizeChange(val) {
        this.pageNum = 1
        this.pageSize = val
        this.commit()
      },

      //  删除按钮
      deleteItem(row) {
        let loading = this.$loading()
        this.$confirm(this.$i18n.t('lang.lab_isdelete'),
            this.$i18n.t('lang.lab_prompt'), {
              confirmButtonText: this.$i18n.t('lang.btn_confirm'),
              cancelButtonText: this.$i18n.t('lang.btn_cancel'),
              type: 'warning'
            })
          .then(() => {
            this.$delete(`/delVideoMonitorById1/${row.id}`).then(
              res => {
                loading.close()
                if (res && res.errCode === 0) {
                  this.$message({
                    type: 'success',
                    message: this.$i18n.t('lang.lab_del_success')
                  })
                  this.pageNum = 1
                  this.commit()
                }
              },
              error => {
                loading.close()
                this.$message.error(error)
              }
            )
          })
          .catch(() => {
            loading.close()
            this.$message({
              type: 'info',
              message: this.$i18n.t('lang.lab_del_can')
            })
          })
      },
      resetForm(formName) {
        this.ruleForm.cell = ''
        this.ruleForm.Building = ''
        this.ruleForm.locationName = ''
        this.ruleForm.videoMonitorTypeId = ''
        this.ruleForm.appId = 'gb28181'
        this.ruleForm.streamId = ''
      },
      // 根据小区选择获取楼号
      selectBuilding(id) {
        this.ruleForm.Building = 0
        this.$get(
          `/gardenGrids/?type=1&parentId=${id}&pageNo=1&pageSize=9999`
        ).then(
          res => {
            if (res && res.errCode === 0) {
              this.houseBuilding = res.list
              this.ruleForm.cell = 0
            }
          },
          error => {
            this.$message.error(error)
          }
        )
      },
    }
  }
</script>
<style lang="scss">
  .tips{
    font-size: 12px;
    margin-left: 20px;
    color: #F56C6C;
    margin-top: 30px;
  }
</style>